module.exports = __webpack_public_path__ + "static/media/Image.110998fc.jpeg";